import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import PropTypes from "prop-types";
import i18n from "i18next";

import { Panel, PanelHeader } from "../Layout/Panel";
import { getAdvancedSearchFields, getAdvancedSearchPeriods, getAdvancedSearchResults } from "../../actions";
import { getAdvancedSearchResultsSelector, getIsLoadingSelector } from "../../selectors/selectors";
import { withNavigationHistory } from "../Common/Navigation/withNavigationHistory";
import AdvancedSearchForm from "./AdvancedSearchForm";
import SearchResultsLoading from "./SearchResults/SearchResultsLoading";
import SearchResultsTable from "./SearchResults/SearchResultsTable";
import SortedListPagination from "../Layout/SortedList/SortedListPagination";

class AdvancedSearchPage extends PureComponent {
  static propTypes = {
    getAdvancedSearchFields: PropTypes.func.isRequired,
    getAdvancedSearchPeriods: PropTypes.func.isRequired,
    getAdvancedSearchResults: PropTypes.func.isRequired,
    fields: PropTypes.array,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    periods: PropTypes.array,
    results: PropTypes.array,
    selectedSearchField: PropTypes.string,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    fields: [],
    isLoading: false,
    isMobile: false,
    periods: [],
    results: [],
    selectedSearchField: "",
    userMetadata: {}
  };

  state = {
    wasFormSubmitted: false,
    viewState: {
      showSearchResults: false,
      itemsWithAllMillOrderShown: [],
      itemsWithAllShipmentShown: [],
      currentPage: 1,
      values: {
        searchQuery: "",
        searchField: "",
        searchPeriod: ""
      }
    }
  };

  componentDidMount() {
    this.props.getAdvancedSearchFields();
    this.props.getAdvancedSearchPeriods();
  }

  componentDidUpdate(prevProps) {
    const { values = {} } = this.state.viewState;

    if (!this.state.wasFormSubmitted && values.searchQuery) {
      this.handleSetDefaultValues(values);
      this.handleSubmit({ ...values });
    }

    if (!values.searchQuery) {
      if (prevProps.fields !== this.props.fields) {
        const defaultField = this.props.fields.find(field => field.isDefault) || {};
        this.handleSetDefaultValues({ searchField: defaultField.code });
      }

      if (prevProps.periods !== this.props.periods) {
        const defaultPeriod = this.props.periods.find(period => period.isDefault) || {};
        this.handleSetDefaultValues({ searchPeriod: defaultPeriod.code });
      }
    }
  }

  get searchFieldValue() {
    const currentField = this.props.fields.find(field => field.code === this.state.viewState.values.searchField) || {};
    return currentField.value;
  }

  handleSetDefaultValues = values => {
    this.setState({ viewState: { ...this.state.viewState, values: { ...this.state.viewState.values, ...values } } });
  };

  handleSetViewState = item => this.setState({ viewState: { ...this.state.viewState, ...item } });

  handleSubmit = values => {
    const { searchQuery, searchField, searchPeriod } = values;

    if (this.state.wasFormSubmitted) {
      this.handleChangePagination(1);
    }

    this.setState(state => ({ wasFormSubmitted: true, viewState: { ...state.viewState, showSearchResults: true, values } }));
    this.props.getAdvancedSearchResults(searchQuery, searchField, searchPeriod);
  };

  handleShowAllMillOrder = id => {
    const { itemsWithAllMillOrderShown = [] } = this.state.viewState;
    this.handleSetViewState({ itemsWithAllMillOrderShown: [...itemsWithAllMillOrderShown, id] });
  };

  handleShowAllShipment = id => {
    const { itemsWithAllShipmentShown = [] } = this.state.viewState;
    this.handleSetViewState({ itemsWithAllShipmentShown: [...itemsWithAllShipmentShown, id] });
  };

  handleChangePagination = currentPage => this.handleSetViewState({ currentPage });

  render() {
    return (
      <Panel className="advanced-search__panel">
        <PanelHeader id={i18n.t("advancedSearch.advancedSearch")} actions={this.actions} isMobile={this.props.isMobile} />
        <AdvancedSearchForm
          fields={this.props.fields}
          periods={this.props.periods}
          initialValues={this.state.viewState.values}
          selectedSearchField={this.props.selectedSearchField}
          onSubmit={this.handleSubmit}
        />

        {this.props.isLoading && <SearchResultsLoading isMobile={this.props.isMobile} />}

        {!this.props.isLoading &&
          this.state.viewState.showSearchResults && (
            <SearchResultsTable
              PaginationComponent={SortedListPagination}
              onChangePagination={this.handleChangePagination}
              onShowAllMillOrder={this.handleShowAllMillOrder}
              onShowAllShipment={this.handleShowAllShipment}
              isMobile={this.props.isMobile}
              itemsWithAllMillOrderShown={this.state.viewState.itemsWithAllMillOrderShown}
              itemsWithAllShipmentShown={this.state.viewState.itemsWithAllShipmentShown}
              currentPage={this.state.viewState.currentPage}
              searchFieldValue={this.searchFieldValue}
              results={this.props.results}
              values={this.state.viewState.values}
              userMetadata={this.props.userMetadata}
            />
          )}
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  const formSelector = formValueSelector("advanced-search");

  return {
    isLoading: getIsLoadingSelector(state, [getAdvancedSearchResults.id]),
    isMobile: state.app.isMobile,
    fields: state.advancedSearch.fields,
    periods: state.advancedSearch.periods,
    results: getAdvancedSearchResultsSelector(state),
    selectedSearchField: formSelector(state, "searchField"),
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  { getAdvancedSearchFields, getAdvancedSearchPeriods, getAdvancedSearchResults }
)(withNavigationHistory(AdvancedSearchPage));



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/AdvancedSearchPage.js